import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

const LoadingPage = (props) => {
  const { claimDone, customStyle, kshemaLoader = false } = props;
  return (
    <>
      {claimDone===true &&(<div className="loading-page">
        <div className="loading-spinner">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>)}
      {!claimDone&& !kshemaLoader && (<div className='loader' style={customStyle}>
        <div className='mb-3'>Loading</div>
        <Spinner animation="border" />
      </div>)}

      {kshemaLoader && (
        <div className="loading-page">
          <img
            src={'/kshemaImages/loading_gif.gif'}
            style={{ height: '100px', width: '100px' }}
            alt='Loading...'
          />
        </div>
      )}
  
    </>
  )
}

export default LoadingPage
